export type LightDarkVariant = 'light' | 'dark';

export const invertLightDarkVariant = (variant: LightDarkVariant) =>
  variant === 'light' ? 'dark' : 'light';
